import {Directive, HostListener} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
    // tslint:disable-next-line
    selector: 'input[type=file]',
    host: {
        '(change)': 'onChange($event.target.files)',
        '(blur)': 'onTouched()',
    },
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: FormlyFieldFileInputValueAccessor, multi: true },
    ],
})
// tslint:disable-next-line:directive-class-suffix
export class FormlyFieldFileInputValueAccessor implements ControlValueAccessor {
    value: any;
    onChange = (_) => { };
    onTouched = () => { };

    writeValue(value) { }
    registerOnChange(fn: any) { this.onChange = fn; }
    registerOnTouched(fn: any) { this.onTouched = fn; }
}
